import { EVENT_SOURCE } from '~~/constants/googleTagManager';
import type { EventSourceLocation } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const getPageCategory = (
  isNewCategoryTree: boolean,
  statusCode?: number,
): EventSourceLocation => {

  if (statusCode) {

    return EVENT_SOURCE.NOT_FOUND;

  }

  if (isNewCategoryTree) {

    return EVENT_SOURCE.NEW_CATEGORY_TREE;

  }

  return EVENT_SOURCE.CATEGORY;

};
